import { ExportFile } from '../types/export/export';
import { http } from '../util/https.util';
import { UploadUtil } from './common/upload.util';

const EXPORT_PRODUCTS = '/api/trigger/stock/product/export';
const PARSE_PRODUCTS = '/api/trigger/stock/product/parse';

export namespace StockTriggerProductRequest {
  interface ProductExportPayload {
    ids: string[];
    configId?: string;
    timezone?: string;
    locale?: string;
  }

  export const download = async (payload: ProductExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT_PRODUCTS, payload)).data;
  };

  interface StockTriggerItem {
    productMasterDataId: string;
    reorderQuantity: number;
    replenishQuantity: number;
  }

  export const parse = async (file: File): Promise<StockTriggerItem[]> => {
    return await UploadUtil.fileWithResponse(PARSE_PRODUCTS, file);
  };
}
